import {
  COPY_CONTACTS_REQUEST,
  COPY_CONTACTS_SUCCESS,
  COPY_CONTACTS_FAILURE,
  DELETE_CONTACT_FAILURE,
  DELETE_CONTACT_REQUEST,
  DELETE_CONTACT_SUCCESS,
  GET_ALL_IMPC_LOCATIONS_DEFAULT_REQUEST,
  GET_ALL_IMPC_LOCATIONS_DEFAULT_SUCCESS,
  GET_ALL_IMPC_LOCATIONS_DEFAULT_FAILURE,
  GET_ALL_DATA_LOCATIONS_DEFAULT_REQUEST,
  GET_ALL_DATA_LOCATIONS_DEFAULT_SUCCESS,
  GET_ALL_DATA_LOCATIONS_DEFAULT_FAILURE,
  ADD_NEW_CONTACT_REQUEST,
  ADD_NEW_CONTACT_SUCCESS,
  ADD_NEW_CONTACT_FAILURE,
  CHECK_EMAIL_ADDRESS_REQUEST,
  CHECK_EMAIL_ADDRESS_SUCCESS,
  CHECK_EMAIL_ADDRESS_FAILURE,
  EDIT_CONTACT_REQUEST,
  EDIT_CONTACT_SUCCESS,
  EDIT_CONTACT_FAILURE,
  GET_CONTACT_DETAILS_REQUEST,
  GET_CONTACT_DETAILS_SUCCESS,
  GET_CONTACT_DETAILS_FAILURE,
  SET_CONTACT_GROUP,
  CLEAR_EMAIL_DUPLICATE,
} from './types/ContactsActionTypes';

export function setContactGroupActionCreator(payload) {
  return {
    type: SET_CONTACT_GROUP,
    payload,
  };
}

export function clearEmailDuplicateActionCreator(payload) {
  return {
    type: CLEAR_EMAIL_DUPLICATE,
    payload,
  };
}

export function getContactDetailsRequestActionCreator(payload) {
  return {
    type: GET_CONTACT_DETAILS_REQUEST,
    payload,
  };
}

export function getContactDetailsSuccessActionCreator(payload) {
  return {
    type: GET_CONTACT_DETAILS_SUCCESS,
    payload,
  };
}

export function getContactDetailsFailureActionCreator(payload) {
  return {
    type: GET_CONTACT_DETAILS_FAILURE,
    payload,
    error: true,
  };
}

export function postCopyContactRequestActionCreator(payload) {
  return {
    type: COPY_CONTACTS_REQUEST,
    payload,
  };
}

export function postCopyContactSuccessActionCreator(payload) {
  return {
    type: COPY_CONTACTS_SUCCESS,
    payload,
  };
}

export function postCopyContactFailureActionCreator(payload) {
  return {
    type: COPY_CONTACTS_FAILURE,
    payload,
    error: true,
  };
}
export function deleteContactRequestActionCreator(payload) {
  return {
    type: DELETE_CONTACT_REQUEST,
    payload,
  };
}

export function deleteContactSuccessActionCreator(data) {
  return {
    type: DELETE_CONTACT_SUCCESS,
    payload: data,
  };
}

export function deleteContactFailureActionCreator(error) {
  return {
    type: DELETE_CONTACT_FAILURE,
    payload: error,
    error: true,
  };
}

export function editContactRequestActionCreator(payload) {
  return {
    type: EDIT_CONTACT_REQUEST,
    payload,
  };
}

export function editContactSuccessActionCreator(data) {
  return {
    type: EDIT_CONTACT_SUCCESS,
    payload: data,
  };
}

export function editContactFailureActionCreator(error) {
  return {
    type: EDIT_CONTACT_FAILURE,
    payload: error,
    error: true,
  };
}

export function checkEmailAddressRequestActionCreator(payload) {
  return {
    type: CHECK_EMAIL_ADDRESS_REQUEST,
    payload,
  };
}

export function checkEmailAddressSuccessActionCreator(payload) {
  return {
    type: CHECK_EMAIL_ADDRESS_SUCCESS,
    payload,
  };
}

export function checkEmailAddressFailureActionCreator(payload) {
  return {
    type: CHECK_EMAIL_ADDRESS_FAILURE,
    payload,
    error: true,
  };
}

export function getAllImpcLocationsRequestActionCreator(payload) {
  return {
    type: GET_ALL_IMPC_LOCATIONS_DEFAULT_REQUEST,
    payload,
  };
}

export function getAllImpcLocationsSuccessActionCreator(payload) {
  return {
    type: GET_ALL_IMPC_LOCATIONS_DEFAULT_SUCCESS,
    payload,
  };
}

export function getAllImpcLocationsFailureActionCreator(payload) {
  return {
    type: GET_ALL_IMPC_LOCATIONS_DEFAULT_FAILURE,
    payload,
    error: true,
  };
}

export function getAllDataLocationsRequestActionCreator(payload) {
  return {
    type: GET_ALL_DATA_LOCATIONS_DEFAULT_REQUEST,
    payload,
  };
}

export function getAllDataLocationsSuccessActionCreator(payload) {
  return {
    type: GET_ALL_DATA_LOCATIONS_DEFAULT_SUCCESS,
    payload,
  };
}

export function getAllDataLocationsFailureActionCreator(payload) {
  return {
    type: GET_ALL_DATA_LOCATIONS_DEFAULT_FAILURE,
    payload,
    error: true,
  };
}

export function addNewContactRequestActionCreator(payload) {
  return {
    type: ADD_NEW_CONTACT_REQUEST,
    payload,
  };
}

export function addNewContactSuccessActionCreator(data) {
  return {
    type: ADD_NEW_CONTACT_SUCCESS,
    payload: data,
  };
}

export function addNewContactFailureActionCreator(error) {
  return {
    type: ADD_NEW_CONTACT_FAILURE,
    payload: error,
    error: true,
  };
}
